var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgErrorInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    enableBackground: "new 0 0 512 512"
  },
  xmlSpace: "preserve"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M254.77,0C114.3,0,0,114.85,0,256c0,141.17,114.82,256,256,256c141.15,0,256-114.83,256-256C512,114.85,396.6,0,254.77,0z  M256,460.8c-112.93,0-204.8-91.88-204.8-204.8S142.5,51.2,254.77,51.2C368.4,51.2,460.8,143.07,460.8,256S368.9,460.8,256,460.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.4,128h51.2v179.2h-51.2V128z M230.4,332.8h51.2V384h-51.2V332.8z"
}))));
export { SvgErrorInfoIcon as ReactComponent };
export default __webpack_public_path__ + "assets/80dc8fb1.svg";